export const PAGE_DASHBOARD: string = '/dashboard';
export const PAGE_LOGIN: string = '/';
export const PAGE_CONTACTS: string = '/contacts';
export const CREATE_DOCUMENT: string = '/create-document';
export const DOCUMENT_TEMPLATE_TRANSLATION: string =
    '/document-templates/translation';
export const PAGE_ARTICLES: string = '/articles';
export const PAGE_DOCUMENT_TEMPLATES: string = '/document-templates';
export const ARTICLE_TRANSLATION: string = '/articles/translation';
export const PAGE_DRAFTS: string = '/drafts';
export const PAGE_DOCUMENTS: string = '/documents';
export const PAGE_KEYWORDS: string = '/keywords';
